import {
    createAction,
    createFeatureSelector,
    createSelector,
    createReducer,
    on,
    props,
    Action,
} from "@ngrx/store";
import { generateRandomEmailCode } from "../helpers/generateCodes";

export type Sms = {
    sender: string;
    title: string;
    text: string;
    subtitle: string;
};

export interface ExperienceState {
    naam: string;
    documentnummer: string;
    dag: string;
    maand: string;
    jaar: string;
    leeftijd: number;
    terms: boolean;
  
    gebruikersnaam: string;
    wachtwoord: string;
  
    telefoonnummer: string;
    gebruikersnaamEmail: string;
    domein: string;
  
    verificatieCode: string;
    emailVerificatieCode: string;
  
    eindeVerificatieCode: string;
  
    sessionEndTime?: number;
  
    sms: Sms[];
    mail: Sms[];
}
export const initialState: ExperienceState = {
    naam: '',
    documentnummer: '',
    dag: '',
    maand: '',
    jaar: '',
    leeftijd: 0,
    terms: false,
  
    gebruikersnaam: '',
    wachtwoord: '',
  
    telefoonnummer: '',
    gebruikersnaamEmail: '',
    domein: '',
  
    verificatieCode: '',
    emailVerificatieCode: '',
  
    eindeVerificatieCode: '',
  
    sms: [],
    mail: [],
};

export const experienceActions = {
    generateVerificatieCode: createAction("[Experience] generateVerificatieCode"),
    generateEmailVerificatieCode: createAction("[Experience] generateEmailVerificatieCode"),
    generateEindeVerificatieCode: createAction("[Experience] generateEindeVerificatieCode"),

    clearVerificatieCode: createAction("[Experience] clearVerificatieCode"),
    clearEmailVerificatieCode: createAction("[Experience] clearEmailVerificatieCode"),
    clearEindeVerificatieCode: createAction("[Experience] clearEindeVerificatieCode"),

    start: createAction("[Experience] start"),
    reset: createAction("[Experience] reset"),

    //   sendSms: (sms: Sms) => void;
    sendSms: createAction("[Experience] sendSms", props<{ sms: Sms }>()),
    //   sendEmail: (email: Sms) => void;
    sendEmail: createAction("[Experience] sendEmail", props<{ email: Sms }>()),
};

const selectExperience = createFeatureSelector<ExperienceState>("experience");

export const experienceSelectors = {
    experienceStarted: createSelector(
        selectExperience,
        (state: ExperienceState) => false
    ),
};

const code = '12345'

const reducer = createReducer(
    initialState,
    on(experienceActions.start, (state, {}) => ({
        ...initialState,
        sessionEndTime: new Date().getTime() + 5 * 60 * 1000, // 5 minutes
    })),
    on(experienceActions.reset, (state, {}) => ({
        ...initialState,
    })),

    on(experienceActions.clearEindeVerificatieCode, (state, {}) => ({
        ...state,
        eindeVerificatieCode: '',
    })),
    on(experienceActions.generateEindeVerificatieCode, (state, {}) => ({
        ...state,
        eindeVerificatieCode: code,
    })),

    on(experienceActions.clearEmailVerificatieCode, (state, {}) => ({
        ...state,
        emailVerificatieCode: '',
    })),
    on(experienceActions.generateEmailVerificatieCode, (state, {}) => ({
        ...state,
        emailVerificatieCode: generateRandomEmailCode(),
    })),

    on(experienceActions.clearVerificatieCode, (state, {}) => ({
        ...state,
        verificatieCode: '',
    })),
    on(experienceActions.generateVerificatieCode, (state, {}) => ({
        ...state,
        verificatieCode: code,
    })),

    on(experienceActions.sendEmail, (state, { email }) => ({
        ...state,
        mail: [...state.mail, email]
    })),
    on(experienceActions.sendSms, (state, { sms }) => ({
        ...state,
        sms: [...state.sms, sms]
    })),
);

export const experienceReducer = (
    state: ExperienceState | undefined,
    action: Action
) => {
    return reducer(state, action);
};
